module.exports = __webpack_public_path__ + "img/kim.373dd0fa.png";